import { render, staticRenderFns } from "./SeleccionRiesgos.vue?vue&type=template&id=07d6a716&"
import script from "./SeleccionRiesgos.vue?vue&type=script&lang=js&"
export * from "./SeleccionRiesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports